module.exports = __webpack_public_path__ + "static/gallery-2@2x-e9ffb74fe3c7605d193db836a31e97b3.jpg";